import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useId, useMemo } from 'react';

/**
 * @param id En caso de añadir mas hijos todos deben tener un id diferente
 */

export function AccordeonItem({
  id: defaultId,
  acordeonId,
  title,
  classContainer,
  styleContainer = {},
  children,
  elementTittle
}) {
  const automaticId = useId();

  const id = useMemo(() => {
    return defaultId || automaticId.replaceAll(':', '-');
  }, [automaticId, defaultId]);

  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className="accordion-button"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={`#${id}`}
          aria-expanded="true"
          aria-controls={id}
        >
          {title}
        </button>
        <div
          className="text-end pe-3 end-0 top-0 position-absolute"
          style={{
            zIndex: 3,
            paddingTop: '1vh'
          }}
        >
          {elementTittle}
        </div>
      </h2>
      <div
        id={id}
        className={classNames('accordion-collapse collapse', classContainer)}
        style={styleContainer}
        data-bs-parent={`#${acordeonId}`}
      >
        <div className="accordion-body">{children}</div>
      </div>
    </div>
  );
}

AccordeonItem.propTypes = {
  id: PropTypes.string,
  acordeonId: PropTypes.string,
  title: PropTypes.string,
  classContainer: PropTypes.string,
  styleContainer: PropTypes.object,
  children: PropTypes.node,
  elementTittle: PropTypes.element
};

export default AccordeonItem;
